export default __webpack_public_path__ + "static/media/logo-tgd-meteo.09a43fd5.png";